// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1J7Rf","colBig":"styles_colBig__221_2","colSmall":"styles_colSmall__1W8FM"};